/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Active_LinksInputs */

const en_no_active_links = /** @type {(inputs: No_Active_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No active links`)
};

const es_no_active_links = /** @type {(inputs: No_Active_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay enlaces activos`)
};

const fr_no_active_links = /** @type {(inputs: No_Active_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun lien actif`)
};

const de_no_active_links = /** @type {(inputs: No_Active_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine aktiven Links`)
};

/** @type {(inputs: No_Active_LinksInputs) => LocalizedString} */
const ja_no_active_links = en_no_active_links;

/** @type {(inputs: No_Active_LinksInputs) => LocalizedString} */
const zh_no_active_links = en_no_active_links;

/** @type {(inputs: No_Active_LinksInputs) => LocalizedString} */
const ar_no_active_links = en_no_active_links;

/** @type {(inputs: No_Active_LinksInputs) => LocalizedString} */
const id_no_active_links = en_no_active_links;

/** @type {(inputs: No_Active_LinksInputs) => LocalizedString} */
const it_no_active_links = en_no_active_links;

/** @type {(inputs: No_Active_LinksInputs) => LocalizedString} */
const ru_no_active_links = en_no_active_links;

/** @type {(inputs: No_Active_LinksInputs) => LocalizedString} */
const pt_no_active_links = en_no_active_links;

/** @type {(inputs: No_Active_LinksInputs) => LocalizedString} */
const ko_no_active_links = en_no_active_links;

/**
* | output |
* | --- |
* | "No active links" |
*
* @param {No_Active_LinksInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_active_links = /** @type {((inputs?: No_Active_LinksInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Active_LinksInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_active_links(inputs)
	if (locale === "es") return es_no_active_links(inputs)
	if (locale === "fr") return fr_no_active_links(inputs)
	if (locale === "de") return de_no_active_links(inputs)
	if (locale === "ja") return ja_no_active_links(inputs)
	if (locale === "zh") return zh_no_active_links(inputs)
	if (locale === "ar") return ar_no_active_links(inputs)
	if (locale === "id") return id_no_active_links(inputs)
	if (locale === "it") return it_no_active_links(inputs)
	if (locale === "ru") return ru_no_active_links(inputs)
	if (locale === "pt") return pt_no_active_links(inputs)
	return ko_no_active_links(inputs)
});